import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { BookmarkParentType } from '~/apollo/generated/v3/graphql';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { TaggedSOItemListV4 } from '~/components/supporting-object/tagged-so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const OUTCROP_PRODUCTION_PAGE = graphql(`
  query OutcropProductionPage($id: ID!) {
    outcropGet(id: $id) {
      id
      production {
        ...productionParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
      }

      studies {
        ...studyParts
        production {
          ...productionParts
          pictures {
            ...soPictureParts
          }
          files {
            ...fileParts
          }
        }
      }
    }
  }
`);

export default function OutcropProductionPage() {
  return (
    <ApolloProviderV4>
      <OutcropProductionPageInner />
    </ApolloProviderV4>
  );
}

function OutcropProductionPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(OUTCROP_PRODUCTION_PAGE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    { query: OUTCROP_PRODUCTION_PAGE, variables: { id: outcropId } },
  ]);

  const outcrop = data?.outcropGet;
  const items = outcrop?.production ?? [];
  const outcropStudies = R.sortBy(s => s.name, outcrop?.studies ?? []);

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <div className="space-y-4">
      <SOItemListV4
        items={items}
        soParentType="outcrop"
        soParentId={outcropId}
        bookmarkParentType={BookmarkParentType.ReservoirModel}
        refetchQueries={refetchQueries}
      />

      <TaggedSOItemListV4
        outcropId={outcropId}
        studies={outcropStudies}
        supportObjectKey="production"
        refetchQueries={refetchQueries}
      />
    </div>
  );
}
